import { render, staticRenderFns } from "./SearchTecnicoGrupo.vue?vue&type=template&id=60907968"
import script from "./SearchTecnicoGrupo.vue?vue&type=script&lang=js"
export * from "./SearchTecnicoGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports